package fr.frux.feature.site.detail

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.heading
import androidx.compose.ui.semantics.semantics
import fr.frux.core.designsystem.components.FruxButton
import fr.frux.core.designsystem.components.FruxModalBottomSheet
import fr.frux.core.designsystem.theme.FruxSpacing
import fr.frux.feature.site.create.PlantingEditor
import fr.frux.feature.site.create.SpeciesPicker
import fr.frux.feature.site.resources.Res
import fr.frux.feature.site.resources.site_planting_add
import fr.frux.feature.site.resources.site_planting_add_submit
import fr.frux.shared.domain.model.Species
import org.jetbrains.compose.resources.stringResource

/**
 * « Il manque une espèce ? » : la recherche de la création de lieu, puis les tranches de l'espèce
 * choisie. [results] exclut déjà les espèces plantées sur le lieu.
 */
@Composable
fun AddPlantingSheet(
    query: String,
    results: List<Species>,
    choice: PlantingChoice,
    onQuery: (String) -> Unit,
    onChoice: (PlantingChoice) -> Unit,
    onSubmit: () -> Unit,
    onDismiss: () -> Unit,
) {
    FruxModalBottomSheet(onDismiss = onDismiss, skipPartiallyExpanded = true) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(horizontal = FruxSpacing.md).padding(bottom = FruxSpacing.lg),
            verticalArrangement = Arrangement.spacedBy(FruxSpacing.sm),
        ) {
            Text(
                text = stringResource(Res.string.site_planting_add),
                style = MaterialTheme.typography.titleLarge,
                modifier = Modifier.semantics { heading() },
            )
            val species = choice.species
            if (species == null) {
                SpeciesPicker(
                    query = query,
                    results = results,
                    onQuery = onQuery,
                    onPick = { onChoice(PlantingChoice(species = it)) },
                )
            } else {
                PlantingEditor(
                    speciesName = species.commonNameFr,
                    count = choice.count,
                    onCount = { onChoice(choice.copy(count = it)) },
                    onRemove = { onChoice(PlantingChoice()) },
                )
            }
            FruxButton(
                text = stringResource(Res.string.site_planting_add_submit),
                onClick = onSubmit,
                enabled = species != null && choice.count != null,
                modifier = Modifier.fillMaxWidth(),
            )
        }
    }
}
